import { http } from 'vue'

export default {
  // load neighborhood from the API server
  loadNeighborhood (context, params = {}) {
    const withParam = params.with ? '?with=' + params.with : ''
    return http.get('neighborhoods' + params.id + withParam)
  },
  // save neighborhood data at local storage and state
  saveNeighborhood (context, payload) {
    context.commit('SAVE_NEIGHBORHOOD', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/neighborhoods/actions.js